import { render, staticRenderFns } from "./addannouncement.vue?vue&type=template&id=556a527e&scoped=true"
import script from "./addannouncement.vue?vue&type=script&lang=js"
export * from "./addannouncement.vue?vue&type=script&lang=js"
import style0 from "./addannouncement.vue?vue&type=style&index=0&id=556a527e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "556a527e",
  null
  
)

export default component.exports